import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { AlmondBloomSettingsModal } from './AlmondBloomSettingsAlmondBloomSettingsModal'

const bloomSettingsSetPermission = 'EDIT_STATION_BLOOM_SETTINGS'

export const AlmondBloomSettingsTitleLink = () => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: bloomSettingsSetPermission })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              almondEventSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Bloom Settings')}
      </ResponsiveMenuItem>
      <AlmondBloomSettingsModal data-role="modal" />
    </>,
  )

  return titleLink
}
